import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import React from "react";

const indicatorVariants = cva(
  "inline-flex items-center justify-center font-bold rounded-full",
  {
    variants: {
      variant: {
        none: "",
        default: "bg-primary text-primary-foreground",
        success: "bg-success text-success-foreground",
        warning: "bg-warning text-warning-foreground",
        disabled: "bg-disabled text-disabled",
        error: "bg-error text-error-foreground",
        azure: "bg-azure text-azure-foreground",

        scheduled: "bg-azure text-azure-foreground",
        starting: "bg-azure text-azure-foreground",
        installing: "bg-azure text-azure-foreground",
        deploying: "bg-azure text-azure-foreground",
        pending: "bg-azure text-azure-foreground",
        running: "bg-azure text-azure-foreground",
        done: "bg-success text-success-foreground",
        ready: "bg-success text-success-foreground",
        completed: "bg-success text-success-foreground",
        canceled: "bg-warning text-warning-foreground",
        cancelled: "bg-warning text-warning-foreground",
        failed: "bg-error text-error-foreground",
        aborted: "bg-error text-error-foreground",
        suspended: "bg-lavender text-lavender-foreground",
        stopped: "bg-lavender text-lavender-foreground",
      },
      size: {
        "2xs": "w-2 h-2 text-[8px]",
        xs: "w-3 h-3 text-[10px]",
        sm: "w-4 h-4 text-xs",
        md: "w-6 h-6 text-sm",
      },
      position: {
        default: "",
        tr: "absolute", // top-right
        tl: "absolute", // top-left
      },
      border: {
        default: "border-2 border-white dark:border-gray-900",
        none: "",
      },
    },
    compoundVariants: [
      { position: "tr", class: "-top-1 -right-1" },
      { position: "tl", class: "-top-1 -left-1" },
      { position: "tr", size: "sm", class: "-top-2 -right-1" },
      { position: "tr", size: "md", class: "-top-3 -right-3" },
      { position: "tl", size: "sm", class: "-top-2 -left-1" },
      { position: "tl", size: "md", class: "-top-3 -left-3" },
    ],
    defaultVariants: {
      variant: "default",
      size: "sm",
      position: "default",
      border: "default",
    },
  },
);

interface IndicatorProps
  extends React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    VariantProps<typeof indicatorVariants> {}

export const Indicator = React.forwardRef<HTMLDivElement, IndicatorProps>(
  ({ children, size, variant, position, border, className, ...props }, ref) => {
    return (
      <div
        {...props}
        ref={ref}
        className={cn(
          indicatorVariants({ variant, position, size, border, className }),
        )}
      >
        {children}
      </div>
    );
  },
);
